// @flow
import React from "react";
import Spinner from "../../Spinner/Spinner";

type OwnProps = {||}

const Loading = (props: OwnProps) => {
    return (<Spinner/>);
};
export default Loading;


// WEBPACK FOOTER //
// ./src/Components/GreyOverlay/Loading/Loading.js